<template>
  <div style="text-align: center; margin-top: 8px">
    <img
      src="../../../assets/images/layout/logo-hemoce.png"
      alt="logo-iph"
      style="width: 200px"
    />
  </div>
</template>

<script>
export default {
  name: 'Logo',
}
</script>
